import React from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Spinner,
} from "reactstrap";
// Redux
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import { loginUser } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/brands/logo-sm-light.png";
import darkLogo from "../../assets/images/logo-sm-dark.png";

//i18n
import { withTranslation } from "react-i18next";

const Login = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { error, loading } = useSelector((state) => state.Login);

  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    dispatch(loginUser(values, history));
  };
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-soft-primary">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Welcome Back !")}</h5>
                        <p>{t("Sign in to Tech4Humans.")}</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="Tech4H" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={mainTheme === "dark" ? logo : darkLogo}
                            alt="Tech4H"
                            className="rounded-circle"
                            height="50"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <AvForm
                      className="form-horizontal"
                      onValidSubmit={handleValidSubmit}
                    >
                      {error && <Alert color="danger">{error}</Alert>}
                      <div className="form-group">
                        <AvField
                          name="email"
                          label={t("Email")}
                          className="form-control"
                          placeholder={t("Email or Username")}
                          type="email"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                            email: {
                              value: true,
                              errorMessage: t("Incorrect email"),
                            },
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <AvField
                          name="password"
                          label={t("Password")}
                          type="password"
                          required
                          placeholder={t("Password")}
                          validate={{
                            required: {
                              value: true,
                              errorMessage: t("Required Field"),
                            },
                            minLength: {
                              value: 4,
                              errorMessage: t("Invalid field"),
                            },
                          }}
                        />
                      </div>

                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customControlInline"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customControlInline"
                        >
                          {t("Remember me")}
                        </label>
                      </div>

                      <div className="mt-3">
                        {loading ? (
                          <button
                            className="btn btn-primary btn-block waves-effect waves-light"
                            style={{ cursor: "no-drop" }}
                            disabled={true}
                          >
                            <Spinner
                              animation="border"
                              style={{
                                height: "19px",
                                width: "19px",
                              }}
                            />
                          </button>
                        ) : (
                          <button
                            className="btn btn-primary btn-block waves-effect waves-light"
                            type="submit"
                          >
                            {t("Log in")}
                          </button>
                        )}
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock mr-1"></i>{" "}
                          {t("Forgot your password?")}
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} Tech4humans.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Login);
